import { ArrowRight, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function QuoteRequestCta() {
  const internalLinks = [{
    label: "Refrigerated Trailers",
    to: "/RefrigeratedTrailersPage"
  }, {
    label: "Rental Options & Pricing",
    to: "/RentalOptionsPricingPage"
  }, {
    label: "Service Areas",
    to: "/ServiceAreasPage"
  }, {
    label: "53-Foot Reefer Trailer",
    to: "/FootRefrigeratedTrailerRentalsPage"
  }, {
    label: "Request a Quote",
    to: "/ContactRequestAQuotePage"
  }];
  return <section id="quoterequestcta" data-nav="light" className="bg-background text-foreground py-16 md:py-24 border-t border-border">
      <div className="container mx-auto px-4 sm:px-6 max-w-5xl">
        <div className="bg-card text-card-foreground border border-border rounded-2xl p-8 md:p-12 shadow-sm text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-default font-bold tracking-tight text-foreground max-w-3xl mx-auto">
            Ready to secure your refrigerated trailer rental?
          </h2>

          <p className="mt-4 text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto">
            Request quote-based pricing for your dates, delivery location, intended use, temperature requirements, preferred trailer size, site-access details, and available power.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button size="lg" asChild className="w-full sm:w-auto font-medium">
              <Link to="/ContactRequestAQuotePage" className="inline-flex items-center gap-2">
                <span>Request a Quote</span>
                <ArrowRight className="size-4" />
              </Link>
            </Button>

            <Button variant="outline" size="lg" asChild className="w-full sm:w-auto font-medium">
              <a href="tel:2135218821" className="inline-flex items-center gap-2">
                <Phone className="size-4" />
                <span>Call 213-521-8821</span>
              </a>
            </Button>
          </div>

          <div className="mt-12 pt-8 border-t border-border">
            <nav aria-label="Related pages" className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-muted-foreground">
              {internalLinks.map((item, i) => <Link key={item.to} data-index={i} to={item.to} className="hover:text-foreground transition-colors font-medium">
                  {item.label}
                </Link>)}
            </nav>
          </div>
        </div>
      </div>
    </section>;
}